import React, { useState, useEffect } from "react";
import Card from "../components/Card";
import axios from "axios";
import CountryStore from "../store/CountryStore";
import { ClipLoader } from "react-spinners";
import CategoryStore from "../store/CategoryStore";

const categoryOrder = [
  "Panel",
  "Installers",
  "Component",
  "Material",
  "Equipment",
  "Seller",
  "Software",
];

function CountrySearch() {
  const [cardsData, setCardsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const globalCountry = CountryStore((state) => state.country);
  const setGlobalCategory = CategoryStore((state) => state.setCategory);
  const sliceCount = window.innerWidth >= 768 && window.innerWidth < 1024 ? 5 : 4;

  async function fetchVendors() {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("country_name", globalCountry);
      formData.append("popular", "asc");
      // console.log(globalCountry);
      const response = await axios.post(
        "/api/get_category_vendor_list.php",
        formData
      );

      const responseStr = response.data;

      try {
        const citiesIndex = responseStr.indexOf('{"cities":');

        if (citiesIndex !== -1) {
          const vendorsStr = responseStr.substring(0, citiesIndex);
          const vendorsData = JSON.parse(vendorsStr);
          setCardsData(vendorsData);
          // console.log(vendorsData);
        } else {
          // console.log("Could not find cities data in response");
          setCardsData(responseStr);
        }
        setLoading(false);
      } catch (parseError) {
        console.error("Error parsing response:", parseError);
        // console.log("Response string:", responseStr);
        setLoading(false);
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchVendors();
  }, []);

  function handleViewMoreClick(category) {
    const formattedCountry = globalCountry.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    setGlobalCategory(formattedCategory);
    window.location.href = `/${formattedCountry}/${formattedCategory}`;
  }

  return (
    <div className="space-y-6 font-inter">
      {loading ? (
        <div className="flex justify-center items-center h-screen">
            <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
        </div>
      ) : (
        categoryOrder.map((category) => {
          const categoryCompanies = cardsData.filter(
            (company) =>
              company.category_id.trim().toLowerCase() ===
              category.trim().toLowerCase()
          );

          return (
            <div key={category}>
              <h2 className="text-xl font-semibold mb-4">{categoryCompanies.length > 0 && category}</h2>
              {categoryCompanies.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8 xl:gap-12 mt-7">
                  {categoryCompanies.slice(0, sliceCount).map((company) => (
                    <Card
                      key={company.id}
                      slug={company.slug}
                      image={company.logo}
                      title={company.company_name}
                      remarks={company.remarks || ""}
                      categoryProp={company.category_id}
                    />
                  ))}
                  {categoryCompanies.length > 4 && (
                    <div className="flex justify-center items-center bg-white md:border rounded-lg">
                      <button
                        className="bg-[#006A4E] p-4 rounded-lg text-center text-white border-[#D9D9D9] rounded-md shadow-sm transition-transform transform hover:scale-105"
                        onClick={() => handleViewMoreClick(category)}
                      >
                        View More
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}

export default CountrySearch;